module.exports = "build/assets/favicon.6c864a93.png";